import GeneralNotification from "./GeneralNotification";

export {
    GeneralNotification,
}